import { render, staticRenderFns } from "./layout-product-details.vue?vue&type=template&id=3c8f1658&scoped=true&"
import script from "./layout-product-details.vue?vue&type=script&lang=js&"
export * from "./layout-product-details.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-details.vue?vue&type=style&index=0&id=3c8f1658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f1658",
  null
  
)

export default component.exports